export type UseFileDrop = {
  props: {
    onDragover: (ev: DragEvent) => void,
    onDrop: (ev: DragEvent) => void; 
  }
}

export type IUseFileDropProps = {
  callback?: (files: Array<File>) => any;
}

export const useFileDrop = (props: IUseFileDropProps = {}) => {
  const handleDragOver = (ev: DragEvent) => {
    ev.preventDefault();
  };

  const getFiles = (ev: DragEvent): Array<File> | null => {
    const data = ev.dataTransfer;
    if (!data) return null;
    if (data.files) {
      return Array.from(data.files);
    }
    if (data.items) {
      return Array.from(data.items)
        .map((it) => it.getAsFile())
        .filter((it) => !!it) as File[];
    } else {
      return Array.from(data.files);
    }
  };

  const onReceiveFiles = (files: File[]) => {
    if (props.callback) {
      props.callback(files);
    }
  };

  const handleDrop = (ev: DragEvent) => {
    ev.preventDefault();
    const files = getFiles(ev);
    if (!files || files.length <= 0) return;
    onReceiveFiles(files);
  };

  return {
    props: {
      onDragover: handleDragOver,
      onDrop: handleDrop 
    }
  } 
};
